import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Axios from "../../config/AxiosConfig";
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";

const EditUserModal = ({ isOpen, onClose, userData, refreshData }) => {
  const [formData, setFormData] = useState({ username: "", phoneNumber: "" });

  useEffect(() => {
    if (userData) {
      setFormData({ username: userData.username || "", phoneNumber: userData.phoneNumber || "" });
    }
  }, [userData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await Axios.put(`/super-admin/update-user/${userData._id}`, formData);
      toast.success("User Updated Successfully!");
      refreshData();
      onClose();
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Error updating user! Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="edit-user-modal" overlayClassName="edit-user-overlay">
      <div className="edit-user-modal-header">
        Edit User
        <button className="edit-user-close-btn" onClick={onClose}>{"\u00D7"}</button>
      </div>

      <div className="edit-user-modal-content">
        <div className="edit-user-form-group">
          <label>Username</label>
          <input type="text" name="username" value={formData.username} onChange={handleChange} disabled/>
        </div>

        <div className="edit-user-form-group">
          <label>Phone Number</label>
          <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} />
        </div>
      </div>

      <div className="edit-user-modal-footer">
        <button className="edit-user-cancel-btn" onClick={onClose}>Cancel</button>
        <button className="edit-user-save-btn" onClick={handleSubmit}>Save</button>
      </div>
    </Modal>
  );
};

export default EditUserModal;
